import { httpsCallable } from 'firebase/functions'
import { functions } from 'fb/index'
import { apiClient } from 'api/client'
import { isRestSlackEnabled } from 'api/featureFlags'
import { toLegacyCallableError } from 'api/errorCompat'

/**
 * Slack 通知 Cloud Function の REST 化ラッパー。
 *
 * 呼び出し側では fire-and-forget だが、旧実装 (httpsCallable) と同じく
 * 失敗時は throw する (REST 経路では callable 風エラーへ変換)。
 */
export const notifySlack = async (message: string): Promise<void> => {
  if (isRestSlackEnabled()) {
    try {
      await apiClient.post('/v1/notifications/slack', { message })
      return
    } catch (e) {
      throw toLegacyCallableError(e)
    }
  }
  const callable = httpsCallable(functions, 'notifySlackDaseruno')
  await callable({ message })
}
